import { parseInventory } from "../global/find-in-store/inventory";

/**
 * The "Want it faster? Find In-Store" link. product-form decides when it
 * shows, and opens the drawer through it from its own Find In-Store button.
 */
class FindInStoreTrigger extends HTMLElement {
  connectedCallback() {
    this.button = this.querySelector("button");
    this.template = this.querySelector("template");

    this.button.addEventListener("click", this._onClick);
  }

  disconnectedCallback() {
    this.button.removeEventListener("click", this._onClick);
  }

  // Read per call: a colourway swap morphs in another product's stock.
  hasStoreStock(variantId) {
    return Object.keys(parseInventory(this)[variantId] || {}).length > 0;
  }

  /**
   * @param {HTMLElement} [opener] Refocused when the drawer closes
   */
  open(opener = this.button) {
    opener.dispatchEvent(
      new CustomEvent("markup-modal:open", {
        bubbles: true,
        detail: {
          target: "find-in-store-modal",
          html: this.template.innerHTML,
        },
      }),
    );
  }

  _onClick = () => this.open();
}

if (!customElements.get("find-in-store-trigger")) {
  customElements.define("find-in-store-trigger", FindInStoreTrigger);
}
